export function sendCurrentUrlToUda(udaExplorer, url, store) {
    if (udaExplorer && udaExplorer.isActive()) {
        const message = {
            action: 'UDAExplorer.TransitionSuccessful',
            args: {
                token: udaExplorer.token(),
                url
            }
        };
        if (store.getters['topic/isTopicView']) {
            message.args.topicId = store.getters['topic/topicId'];
        }
        udaExplorer.sendMessage(message);
    }
}

export function sendGraphicIdToUda(udaExplorer, graphicId, graphicSubtype) {
    if (udaExplorer && udaExplorer.isActive()) {
        udaExplorer.sendMessage({
            action: 'UDAExplorer.TransitionSuccessful',
            args: {
                token: udaExplorer.token(),
                graphicId,
                graphicSubtype
            }
        });
    }
}